import { type Prisma, UserLocale } from "@prisma/client";
import { type AsyncReturnType } from "type-fest";
import { type AppContext } from "~/lib/context";
import { CacheKeys } from "~/lib/external/redis/cacheKeys";

export const selectComptryxLocationForSelector = {
  id: true,
  name: true,
  country: {
    select: {
      id: true,
      name: true,
      alpha2: true,
    },
  },
} satisfies Prisma.ComptryxLocationSelect;

export type ComptryxLocationForSelector = Prisma.ComptryxLocationGetPayload<{
  select: typeof selectComptryxLocationForSelector;
}>;

export const fetchComptryxLocations = async (ctx: AppContext) => {
  return fetchCached(ctx, async () => {
    return ctx.prisma.comptryxLocation.findMany({
      where: {
        enabled: true,
      },
      select: selectComptryxLocationForSelector,
      orderBy: [{ country: { name: "asc" } }, { name: "asc" }],
    });
  });
};

export const fetchComptryxLocationsByIds = async (ctx: AppContext, ids: number[]) => {
  return ctx.prisma.comptryxLocation.findMany({
    where: { id: { in: ids } },
    select: selectComptryxLocationForSelector,
  });
};

const fetchCached = async <T>(ctx: AppContext, fn: () => Promise<T>) => {
  const locale = ctx.user?.locale ?? UserLocale.EN;
  const cacheKey = `${CacheKeys.ComptryxLocations}-${locale}`;

  return ctx.remember(cacheKey, fn);
};

export type FetchComptryxLocationsResult = AsyncReturnType<typeof fetchComptryxLocations>;
